<template>
  <div class="bubbleContainer">
    <v-btn v-show="! display" class="helpButton" @click="display = true">
      <v-icon>help_outline</v-icon>
      {{ $t('HELP_TITLE') }}
    </v-btn>
    <div v-show="display" class="speech-bubble">
      <v-icon class="hoverPointer closeIcon" @click="close()">close</v-icon>
      <p v-html="$t('HELP_TEXT')"></p>
    </div>
  </div>

</template>

<script lang="ts">
import Component from 'vue-class-component'
import BasicComponent from "@/global/BasicComponent";

@Component({
  components: {}
})
export default class HelpBubble extends BasicComponent {

  display: boolean = false;

  close() {
    this.display = false;
  }

}

</script>
<style lang="scss" scoped>

$background: #7f99bb;

.helpButton {
  /*
  position: fixed;
    bottom: 10px;
    left: 10px;
   */
  background-color: $background !important;
  color: white !important;
  height: 58px;
  display: inline-block;
}

.bubbleContainer {
  position: relative;
  z-index: 45;
  display: inline-block;
  margin-left: 15px;

  .closeIcon {
    position: absolute;
    top: 10px;
    right: 10px;
    color: white;
    z-index: 10;
  }
}

.speech-bubble {
  position: fixed;
  background: $background;
  border-radius: .4em;
  bottom: 45px;
  right: 85px;
  max-width: 80vw;
  padding: 15px;
  padding-bottom: 0;
  padding-right: 40px;
  margin-left: 25px;
  color: white;
  z-index: 45;
}

.speech-bubble:after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 80%;
  width: 0;
  height: 0;
  border: 33px solid transparent;
  border-top-color: $background;
  border-bottom: 0;
  border-right: 0;
  margin-left: -16.5px;
  margin-bottom: -33px;
}

</style>
<style lang="scss">

.copyright {
  p {
    margin: 0 !important;
  }
}

</style>
